import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { NarrowedEntityData } from '@adornis/bh-util/selectionset-types.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import type { TimeSlot } from '../datetime/time-slot.js';
import { readEntitiesByIDs } from '../server/entity-reads.js';
import { Einzelberatung } from './einzelberatung.js';
import { Participation } from './Participation.js';

@Entity()
export class ParticipationEinzelberatung extends Participation<Einzelberatung> {
  static override _class = 'ParticipationEinzelberatung';

  @validate(nonOptional())
  @Field(type => String)
  timeslotID!: string;

  public override async timespan() {
    const fields = { slots: { _id: 1, start: 1, end: 1, isNonBlocking: 1 } } as const;
    const [product] = await readEntitiesByIDs<typeof Einzelberatung, typeof fields>(
      Einzelberatung,
      [this.productID],
      fields,
    );

    if (!product) throw new Error('invalid product instance');

    const timeslot = product.slots.find(slot => slot._id === this.timeslotID);
    if (!timeslot) throw new Error('timeslot not found');
    return [timeslot] as NarrowedEntityData<TimeSlot, { _id: 1; start: 1; end: 1; isNonBlocking: 1 }>[];
  }
}
